export default __webpack_public_path__ + "static/media/ferramenta-baixar-foto-img8.59f6115c.jpeg";